import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Label, Input } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useUniqueId from '../../hooks/useUniqueId.js';

var _excluded = ["id", "checked", "disabled", "onChange", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ToggleButton = function ToggleButton(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? undefined : _ref$id,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onChange = _ref.onChange,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var inputId = id || useUniqueId('toggleButton-');
  return /*#__PURE__*/jsxs(Label, _objectSpread(_objectSpread({
    checked: checked,
    $disabled: disabled
  }, rest), {}, {
    children: [children, /*#__PURE__*/jsx(Input, {
      type: "checkbox",
      id: inputId,
      onChange: onChange,
      checked: checked,
      "aria-checked": checked,
      "aria-disabled": disabled
    })]
  }));
};
var ToggleButton$1 = ToggleButton;

export { ToggleButton$1 as default };
//# sourceMappingURL=ToggleButton.js.map
